(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["check_requirements/includes/_requirement_container_view.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"results-block results-block--";
if(runtime.contextOrFrameLookup(context, frame, "passedRequirements")) {
output += "success";
;
}
else {
output += "warning";
;
}
output += "\">\n    \n    <div class=\"result-block__headline\">\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "passedRequirements")) {
output += "\n        <svg class=\"result-block-headline-icon result-block__headline-icon--success nebula-icon--xxl\" aria-hidden=\"true\" focusable=\"false\">\n            <use xlink:href=\"";
output += runtime.suppressValue((lineno = 6, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "edde_static"), "edde_static", context, ["node_modules/@discoveryedu/nebula-icons/nebula.svg#badge-correct"])), env.opts.autoescape);
output += "\"></use>\n        </svg>\n        <span class=\"nebula-screenreader-only\">";
output += runtime.suppressValue((lineno = 8, colno = 51, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Passing Requirements"])), env.opts.autoescape);
output += "</span>\n        <h3 class=\"result-block__header\">";
output += runtime.suppressValue((lineno = 9, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["You have everything you need to get started with Discovery Education"])), env.opts.autoescape);
output += "</h3>\n    \n    </div>\n    ";
;
}
else {
output += "\n        <svg class=\"result-block-headline-icon result-block__headline-icon--warning nebula-icon--xxl\" aria-hidden=\"true\" focusable=\"false\">\n            <use xlink:href=\"";
output += runtime.suppressValue((lineno = 14, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "edde_static"), "edde_static", context, ["node_modules/@discoveryedu/nebula-icons/nebula.svg#exclamation"])), env.opts.autoescape);
output += "\"></use>\n        </svg>\n        <div class=\"nebula-screenreader-only\">";
output += runtime.suppressValue((lineno = 16, colno = 50, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Passing Requirements"])), env.opts.autoescape);
output += "</div>\n        <h3 class=\"result-block__header\">";
output += runtime.suppressValue((lineno = 17, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["You do not have everything you need to get started with Discovery Education"])), env.opts.autoescape);
output += "</h3>\n    \n    </div>\n\n    <div class=\"results-suggestion-container\">\n        <p class=\"results-summary-header\">";
output += runtime.suppressValue((lineno = 22, colno = 46, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["For the best experience possible:"])), env.opts.autoescape);
output += "</p>\n        <ul>\n            ";
if(!runtime.contextOrFrameLookup(context, frame, "browserSupported")) {
output += "\n            <li>";
output += runtime.suppressValue((lineno = 25, colno = 20, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Please upgrade your browser to use Discovery Education"])), env.opts.autoescape);
output += "</li>\n            ";
;
}
output += "\n            ";
if(!runtime.contextOrFrameLookup(context, frame, "readerSupported")) {
output += "\n            <li>";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 28, colno = 20, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Please install the latest version of <a href=\"https://get.adobe.com/reader/\">Adobe PDF Reader</a>"]))), env.opts.autoescape);
output += "</li>\n            ";
;
}
output += "\n        </ul>   \n    </div>\n    \n    ";
;
}
output += "\n    <div class=\"results-summary-container\">\n        <p class=\"results-summary-header\">";
output += runtime.suppressValue((lineno = 35, colno = 46, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Your System Summary:"])), env.opts.autoescape);
output += "</p>\n        <ul class=\"results-summary-list\">\n            <li><span class=\"results-summary-bold\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 37, colno = 55, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Your Browser:</span> %(browser)s %(version)s",runtime.makeKeywordArgs({"browser": runtime.contextOrFrameLookup(context, frame, "browser"),"version": runtime.contextOrFrameLookup(context, frame, "browserVersion")})]))), env.opts.autoescape);
output += "</li>\n            <li><span class=\"results-summary-bold\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 38, colno = 55, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["PDF Reader:</span> %(pdf)s",runtime.makeKeywordArgs({"pdf": runtime.contextOrFrameLookup(context, frame, "pdfReader")})]))), env.opts.autoescape);
output += "</li>\n            <li>";
output += runtime.suppressValue((lineno = 39, colno = 20, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["JavaScript is enabled"])), env.opts.autoescape);
output += "</li>\n        </ul>\n    </div>\n    \n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

define("apps/check-requirements/templates/includes/_requirement_container_view", function(){});

